import { useTranslation } from 'libs/i18n'
import { useNavigate } from 'libs/router'
import { routes } from 'config/routes'
import type { Option } from 'shared/components/ContextMenu/types'
import type { CouponItem } from 'features/coupons/types/coupons.types'

type UseContextMenuOptionsProps = {
	onToggleActive: (id: number, is_active: boolean) => void
	onDelete: (id: number) => void
}

export const useContextMenuOptions = ({ onToggleActive, onDelete }: UseContextMenuOptionsProps) => {
	const { t } = useTranslation()
	const navigate = useNavigate()

	return (coupon: CouponItem): Option[] => [
		{
			label: t('Edit'),
			action: (id: number) => navigate(routes.couponEdit(String(id)))
		},
		// legacy coupons (null is_active) can't be toggled: the PATCH would 400 without dates
		...(coupon.is_active === null
			? []
			: [
					{
						label: coupon.is_active ? t('Deactivate') : t('Activate'),
						action: (id: number) => onToggleActive(id, !coupon.is_active)
					}
				]),
		{
			label: t('History'),
			action: (id: number) => navigate(routes.couponHistory(String(id)))
		},
		{
			label: t('Delete'),
			action: onDelete
		}
	]
}
